import { useAuth } from '@/store/auth/auth.store';
import { hasAnyRole, type UserRole } from '@/utils/roles';

export const useRoles = () => {
  const userRoles = useAuth((state) => state.session?.userRoles);
  const primaryRole = useAuth((state) => state.session?.primaryRole);

  return {
    hasAnyRole: (roles: readonly UserRole[]) => hasAnyRole(userRoles, roles),
    userRoles,
    primaryRole,
  };
};
